import cn from 'classnames'
import React from 'react'

interface FillProps {
  className?: string
  name: string
  hex?: string
  reverseColor?: boolean
}

export const Fill = ({ name, hex, className, reverseColor }: FillProps) => {
  return (
    <div className={cn(
      `p-4 rounded text-sm flex-1 border ${name} ${className}`,
      {"text-white" : reverseColor }
    )} 
    >
      {name} <br/>
      { hex ? "#" : ""} {hex}
    </div>
  )
}
